import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import 'react-responsive-modal/styles.css';
import _fetch from "../../config/api";
import toasted from "../../config/toast";
import { useTranslation } from 'react-i18next';

const CompundInterestCalculator = (props: any) => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${props.pageTitle} | ${titleDescription}`;
    });

    const [percentage, setPercentage] = useState();
    const [amount, setAmount] = useState();
    const [timeType, setTimeType] = useState();
    const [returnOfInvest, setReturnOfInvest] = useState(Number);

    const SubmitIncome = async () => {
        let FinalAmount = 0;
        let P = parseFloat(amount);
        let R = parseFloat(percentage);
        let T = parseFloat(timeType);
        if (!P || !R || !T) {
            toasted.error(t("Please fill all fields"));
            return;
        }
        const A = P * Math.pow((1 + R / 100), T);
        const CI = A - P;
        console.log(`Final Amount: ₹${A.toFixed(2)}`);
        console.log(`Compound Interest: ₹${CI.toFixed(2)}`);
        setReturnOfInvest(A);
    }

    return (
        <>
            <main>
                <div className="buy_section loader_main">
                    {/* {loading &&
                        <div className="spinner_bg">

                            <div className="color_ring">  <ColorRing
                                visible={true}
                                height="80"
                                width="80"

                                ariaLabel="blocks-loading"
                                wrapperStyle={{}}
                                wrapperClass="blocks-wrapper"
                                colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                            /></div>

                        </div>
                    } */}
                    <div className="coustom_container">
                        <div className="buy_top_sec">
                            <h4>
                                {t("Calculate Interest")}
                            </h4>
                        </div>
                        <div className="row cards_sec">
                            <div className="col-lg-4 col-md-6 col-sm-6">
                                <div className="card christmas_card mb-4">
                                    <div className="card-body">
                                        <div className="card_bottom_Sec">
                                            <div className="buy-section">
                                                <p className="select_amount">
                                                    <label>Amount</label>
                                                    <input type="number" placeholder='Enter Amount' onChange={(e: any) => setAmount(e.target.value)} value={amount} />
                                                </p>
                                                <p className="select_amount">
                                                    <label>Rate</label>
                                                    <input type="number" placeholder='Enter Percentage' onChange={(e: any) => setPercentage(e.target.value)} value={percentage} />
                                                </p>
                                                <p className="select_amount">
                                                    <label>Time Period</label>
                                                    <select className="form-control btn-square" onChange={(e: any) => setTimeType(e.target.value)} value={timeType}>
                                                        <option value="">--Select Time Period--</option>
                                                        <option value="12">12 Month</option>
                                                        <option value="24">24 Month</option>
                                                        <option value="36">36 Month</option>
                                                    </select>
                                                </p>
                                                {returnOfInvest > 0 ?
                                                    <p className="select_amount">
                                                          <label>Total Return</label>
                                                        <input type="number" placeholder='Total Return' value={returnOfInvest} />
                                                    </p>
                                                    : ''}
                                                <button className="button_style w-100 mt-3" onClick={() => SubmitIncome()}>
                                                    {`${t("Submit")}`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default CompundInterestCalculator;
